import { render, staticRenderFns } from "./CreateList.vue?vue&type=template&id=67d4dc76&scoped=true"
import script from "./CreateList.vue?vue&type=script&lang=js"
export * from "./CreateList.vue?vue&type=script&lang=js"
import style0 from "./CreateList.vue?vue&type=style&index=0&id=67d4dc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4dc76",
  null
  
)

export default component.exports